import type { ContentBundle } from '../schema';
import { aboutPageContent, promises, values } from './about';
import { companyContent } from './company';
import { contactPageContent } from './contact';
import { ctas, defaultGlobalCta } from './ctas';
import { faqs } from './faqs';
import { giftingFeatures, giftingOptions, homeCollections, homePageContent } from './home';
import { journeyPageContent, timeline } from './journey';
import { navigationContent, primaryNavigation } from './navigation';
import { pages } from './pages';
import { seoContent } from './seo';
import { siteContent } from './site';
import { testimonials } from './testimonials';
import { weddingGiftingPageContent } from './weddingGifting';

export { COLLECTION_FILTER_GROUPS, COLLECTIONS, COLLECTIONS_PAGE_CONTENT } from './collections';
export type {
  Collection,
  CollectionFabric,
  CollectionFilterGroup,
  CollectionFilterOption,
  CollectionsHeroContent,
  CollectionsStory,
  CollectionsValueProp,
  CollectionZari,
} from './collections';

export {
  aboutPageContent,
  companyContent,
  contactPageContent,
  ctas,
  defaultGlobalCta,
  faqs,
  giftingFeatures,
  giftingOptions,
  homeCollections,
  homePageContent,
  journeyPageContent,
  navigationContent,
  pages,
  primaryNavigation,
  promises,
  seoContent,
  siteContent,
  testimonials,
  timeline,
  values,
  weddingGiftingPageContent,
};

export const enInContent = {
  locale: 'en-IN',
  site: siteContent,
  navigation: navigationContent,
  company: companyContent,
  seo: seoContent,
  ctas,
  defaultGlobalCta,
  pages,
  testimonials,
  faqs,
} satisfies ContentBundle;
